// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__GVvqO","header":"Modal_header__sSqJl","content":"Modal_content__NL87M"};